import React from 'react';
import { ReturnPolicy } from '../../../generated/types/globalTypes';
import { ReturnPolicyCopy } from '../../ReturnPolicyInformation/ReturnPolicyCopy';
import { ShortReturnPolicyCopyApproach } from '../../ReturnPolicyInformation/ShortReturnPolicyCopy';

interface Props {
  returnPolicy: ReturnPolicy | null;
}

export const ProductDetailsShippingAndReturnsCopy: React.FC<Props> = ({ returnPolicy }) => {
  if (!returnPolicy) return null;

  return (
    <ReturnPolicyCopy
      returnPolicy={returnPolicy}
      approach={ShortReturnPolicyCopyApproach.Singular}
    />
  );
};
